import React, { SVGProps } from 'react';

export const RiseIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 114,
  height = 40,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 114 40"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.1616 1.44333C9.9554 1.44333 1.67773 9.75043 1.67773 19.9968C1.67773 30.2432 9.95223 38.5535 20.1616 38.5535C30.3677 38.5535 38.6454 30.2464 38.6454 19.9968C38.6454 9.75043 30.3709 1.44333 20.1616 1.44333ZM25.3929 29.2449L25.3549 17.6919L13.8314 29.2481L8.18523 29.2449L22.6221 14.7608H17.3432C15.7124 14.7608 14.3856 16.0928 14.3856 17.7301C14.3856 18.4104 14.6167 19.0367 15.0031 19.539L12.1721 22.3875C11.0669 21.1508 10.3924 19.5199 10.3924 17.7333C10.3924 13.8865 13.5084 10.755 17.3432 10.755H29.3829V29.2481L25.3929 29.2449Z"
        fill="#5E59EC"
      />
      <path
        d="M53.1641 31.9218H47.5781V13.079H53.1641V17.6379C54.13 14.1281 56.5398 12.6753 58.4683 12.6753C59.7951 12.6753 60.7989 12.9169 61.6824 13.362L60.6786 18.4041C59.6748 17.9209 58.709 17.8382 57.8255 17.8382C54.6113 17.8382 53.1641 20.3815 53.1641 25.3442V31.9218Z"
        fill="#1C1F32"
      />
      <path
        d="M67.3476 2.82956C69.2349 2.82956 70.7644 4.2411 70.7644 6.09772C70.7644 7.95434 69.2381 9.40721 67.3476 9.40721C65.4602 9.40721 63.8516 7.95434 63.8516 6.09772C63.8516 4.2411 65.4602 2.82956 67.3476 2.82956ZM70.1216 31.9219H64.5767V13.0791H70.1216V31.9219Z"
        fill="#1C1F32"
      />
      <path
        d="M80.128 24.1742C74.5009 22.6419 74.4629 19.7775 74.5009 18.0417C74.5421 15.2567 77.8765 12.6753 81.8159 12.6753C85.5525 12.6753 89.4919 14.3284 89.533 18.9286H84.2669C84.2257 17.5171 83.0224 17.2755 82.1357 17.2755C80.9292 17.2755 80.1249 17.8414 80.166 18.687C80.2072 19.2529 80.6885 19.8156 81.8127 20.0986L84.9889 20.9474C89.5299 22.1968 90.0935 25.2233 90.0935 26.4346C90.0935 30.4276 85.9135 32.3256 81.9742 32.3256C78.1552 32.3256 74.1779 30.027 74.1367 25.8306H79.3617C79.4029 26.921 80.6062 28.0083 82.1357 28.0083C83.3802 27.967 84.4252 27.4042 84.4252 26.4346C84.4252 25.6271 83.9439 25.1852 82.5759 24.8196L80.128 24.1742Z"
        fill="#1C1F32"
      />
      <path
        d="M111.273 28.4915C109.386 31.3146 105.886 32.3256 102.713 32.3256C97.3269 32.3256 92.9062 28.3707 92.9062 22.4416C92.9062 16.5093 97.3269 12.6784 102.713 12.6784C108.059 12.6784 112.318 16.6714 112.318 22.6037C112.318 23.087 112.277 23.8531 112.239 24.3395H98.4954C98.7772 26.5173 101.149 27.4869 103.116 27.4869C104.642 27.4869 106.292 26.921 107.216 25.7129L111.273 28.4915ZM106.691 20.8266C106.409 18.5281 104.319 17.5998 102.751 17.5998C101.184 17.5998 99.0527 18.4486 98.5714 20.8266H106.691Z"
        fill="#1C1F32"
      />
    </svg>
  );
};
